import { managementGroupConfigurationsStyles } from "@guestsupply/App/Widgets/ManagementGroupOptions/MGConfigurations";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

managementGroupConfigurationsStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 400px;
        padding: 25px;
    `,
};
managementGroupConfigurationsStyles.groupDynamicDropdown = {
    cssOverrides: {
        dropdownWrapper: css`
            margin-bottom: 15px;
        `,
    },
};
managementGroupConfigurationsStyles.minimumOrderTextField = {
    css: css`
        margin-bottom: 15px;
    `,
};

managementGroupConfigurationsStyles.checkboxStyle = {
    css: css`
        margin-bottom: 15px;
    `,
};
managementGroupConfigurationsStyles.actionButtons = {
    css: css`
        display: flex;
        justify-content: flex-end;
    `,
};

managementGroupConfigurationsStyles.submitButton = {
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};
